import { Component } from 'react';
import ProgressBar from './ProgressBar';
import Loader from './Loader';
import SuggestionList from './SuggestionList.js';
import './Form.scss';
import languages from '../languages';
import Tooltip from './Tooltip';
import Fetch from '../lib/Fetch.js';
import KeywordUsage from './KeywordUsage';
import ErrorMessage from './ErrorMessage.js';

class Form extends Component {
	constructor(props) {
		super(props);
		this.state = {
			titleWorking: false,
			descrWorking: false,
			titleWorkingMessage: '',
			descrWorkingMessage: '',
			titleProposals: [],
			titleWordStats: [],
			descrProposals: [],
			descrWordStats: [],
			top10: [],
			errors: {},
			langMessage: '',
		}
		this.handleFetchClick = this.handleFetchClick.bind(this);
		this.handleFixTitleClick = this.handleFixTitleClick.bind(this);
		this.handleFixDescrClick = this.handleFixDescrClick.bind(this);
		this.changeLanguage = this.changeLanguage.bind(this);
		this.handleCheckLanguageClick = this.handleCheckLanguageClick.bind(this);
	}

	handleFetchClick(event) {
		event.preventDefault();
		if (this.props.url) {
			this.updatePageData();
		}
	}

	handleCheckLanguageClick(event) {
		event.preventDefault();
		this.detectLanguage();
	}

	isMarkupNeeded() {
		const {url, markup, markupSrc} = this.props;

		return (url && url !== markupSrc) || !markup;
	}

	async handleFixTitleClick(event) {
		event.preventDefault();
		const {isPro, isAppsumo, markup, url} = this.props;
		if (!isPro) {
			if (isAppsumo) {
				alert(window?.t?.AVAILABLE_IN_ADV_APPSUMO);
			} else {
				alert(window?.t?.AVAILABLE_IN_ADV);
			}
			return;
		}

		if ((!url && !markup)) {
			this.setState({errors: {
				url: window.t?.MSG_NO_URL,
			}});
			return;
		}

		if (this.isMarkupNeeded()) {
			let pageData = {};

			this.setState({
				titleWorking: true,
				titleWorkingMessage: window?.t?.DETECTING_LANGUAGE,
			});
			this.detectLanguage();
			this.setState({
				titleWorkingMessage: window?.t?.FETCHING_PAGE_DATA,
			})
			pageData = await this.updatePageData();
			this.setState({
				titleWorking: false,
				titleWorkingMessage: '',
			});

			this.fixData({
				markup: pageData.markup,
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
				translationLang: this.props.translationLanguage,
				what: 'title',
			});
		} else if (markup) {
			this.fixData({
				markup: this.props.markup,
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
				translationLang: this.props.translationLanguage,
				what: 'title',
			});
		} else {
			this.setState({errors: {
				url: window?.t?.ERR_MISSING_URL,
			}});
		}

	}

	async handleFixDescrClick(event) {
		event.preventDefault();
		const {isPro, markup, isAppsumo, url} = this.props;
		if (!isPro) {
			if (isAppsumo) {
				alert(window?.t?.AVAILABLE_IN_ADV_APPSUMO);
			} else {
				alert(window?.t?.AVAILABLE_IN_ADV);
			}
			return;
		}

		if ((!url && !markup)) {
			this.setState({errors: {
				url: window.t?.MSG_NO_URL,
			}});
			return;
		}

		if (this.isMarkupNeeded()) {
			let pageData = {};
			this.setState({
				descrWorking: 'descr',
				descrWorkingMessage: window?.t?.FETCHING_PAGE_DATA,
			});
			this.detectLanguage();
			pageData = await this.updatePageData();
			this.setState({
				descrWorking: false,
				descrWorkingMessage: '',
			});

			this.fixData({
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
				translationLang: this.props.translationLanguage,
				markup: pageData.markup,
				what: 'description',
			});
		} else if (markup) {
			this.fixData({
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
				markup: this.props.markup,
				translationLang: this.props.translationLanguage,
				what: 'description',
			})
		} else {
			alert(window?.t?.NO_URL);
		}
	}

	handleLanguageChange(event) {
		this.changeLanguage(event.target.value);
	}

	handleBrandChange(event) {
		this.props.changeCallback('brand', event.target.value);
		window.localStorage.setItem(this.props.toolSlug + '-language', event.target.value);
	}

	render() {
		const {isPro, isAppsumo} = this.props;

		let langInfo = this.state.languageName || this.state.langMessage;

		const fixTitle = this.state.titleWorking
			? <Loader message={this.state.titleWorkingMessage} />
			: isPro
				? (<p className="buttons"><button className="button primary" onClick={this.handleFixTitleClick}>{window?.t?.FIX_BTN_TEXT}</button></p>)
				: (<p className="buttons"><button className="button primary has-tooltip" onClick={this.handleFixTitleClick}>{window?.t?.FIX_BTN_TEXT}<Tooltip text={isAppsumo ? window?.t?.AVAILABLE_IN_ADV_APPSUMO : window?.t?.AVAILABLE_IN_ADV} /></button></p>);

		const fixDescr = this.state.descrWorking
			? <Loader message={this.state.descrWorkingMessage} />
			: isPro
				? <p className="buttons"><button className="button primary" onClick={this.handleFixDescrClick}>{window?.t?.FIX_BTN_TEXT}</button></p>
				: <p className="buttons"><button className="button primary has-tooltip" onClick={this.handleFixDescrClick}>{window?.t?.FIX_BTN_TEXT}<Tooltip text={isAppsumo ? window?.t?.AVAILABLE_IN_ADV_APPSUMO : window?.t?.AVAILABLE_IN_ADV} /></button></p>

		return (
			<form className="serp-form">
				<div className="form-field">
					<label htmlFor="url">{window?.t?.LABEL_URL}</label>
					<input type="url" id="url" value={this.props.url} onChange={event => this.props.changeCallback('url', event.target.value)} />
					{this.state.errors.url ? (
						<ErrorMessage text={this.state.errors.url} />
					) : ''}
					<p className="buttons">
					<button className="button primary" onClick={this.handleFetchClick}>{window?.t?.FETCH_DATA}</button>
					</p>
				</div>

				<div className="advanced-settings">
					<p>
						<input type="checkbox" id="show-advanced" value="1" />
						<label className="toggle-label" htmlFor="show-advanced">{window?.t?.LABEL_ADVANCED}</label>
					</p>
					<div className="toggle-content">
						<div className="form-field">
							<label htmlFor="language">{window?.t?.LABEL_LANGUAGE}</label>
							<select name="language" id="language" data-option="language" value={this.props.language} onChange={event => this.props.changeCallback('language', event.target.value)}>{this.prepareLangOptions()}</select>
							{this.props.langDetection ? (
								<span className="language-detector">
									<button className="button secondary" onClick={this.handleCheckLanguageClick}>{window?.t?.DETECT_LANGUAGE}</button>
									<span className="info">{langInfo}</span>
								</span>
							) : (
								<span className="language-detector">
									<button className="button secondary has-tooltip" disabled>{window?.t?.DETECT_LANGUAGE}<Tooltip text={window?.t?.AVAILABLE_IN_ADV} /></button>
									<span className="info">{langInfo}</span>
								</span>
							)}
						</div>
						<div className="form-field">
							<label htmlFor="translation-language">{window?.t?.LABEL_TRANSLATE} ({window?.t?.LABEL_OPTIONAL})</label>
							<select name="translation-language" id="translation-language" data-option="translation-language" value={this.props.translationLanguage} onChange={event => this.props.changeCallback('translationLanguage', event.target.value)}>{this.prepareLangOptions()}</select>
						</div>
						<div className="form-field">
							<label htmlFor="markup">{window?.t?.LABEL_PAGE_MARKUP} ({window?.t?.LABEL_OPTIONAL})</label>
							<textarea rows="4" id="markup" value={this.props.markup} onChange={event => this.props.changeCallback('markup', event.target.value)} />
						</div>
					</div>
				</div>

				<div className="form-field">
					<label htmlFor="keywords">{window?.t?.LABEL_KEYWORDS}</label>
					<input type="text" id="keywords" required value={this.props.keywords} onChange={event => this.props.changeCallback('keywords', event.target.value)} />
					{this.state.errors.keywords ? (
						<ErrorMessage text={this.state.errors.keywords} />
					) : ''}
				</div>
				<div className="form-field">
					<label htmlFor="brand">{window?.t?.LABEL_BRAND} ({window?.t?.LABEL_OPTIONAL})</label>
					<input type="text" id="brand" value={this.props.brand} onChange={event => this.props.changeCallback('brand', event.target.value)} />
				</div>
				<div className="form-field">
					<label htmlFor="title">{window?.t?.LABEL_TITLE}</label>
					<ProgressBar text={this.props.title} maxLength="600" minTextLength="30" maxTextLength="60" optimalMinTextLength="35" sampleFontSize="20" />
					<textarea rows="2" id="title" value={this.props.title} onChange={event => this.props.changeCallback('title', event.target.value)} />
					{fixTitle}
					<SuggestionList
					values={this.state.titleProposals}
					selectedValue={this.props.title}
					fieldName="title"
					callback={this.props.changeCallback}
					/>
					<KeywordUsage
					keywordStats={this.state.titleWordStats}
					translations={!!this.props.translationLanguage}
					words={this.props.title ? this.text2words(this.props.title) : []}
					/>

				</div>
				<div className="form-field">
					<label htmlFor="descr">{window?.t?.LABEL_DESCRIPTION}</label>
					<ProgressBar text={this.props.descr} maxLength="960" minTextLength="70" maxTextLength="158" optimalMinTextLength="130" sampleFontSize="14" labelPrefix={window?.t?.DESKTOP + ': '} />
					<textarea rows="3" id="descr" value={this.props.descr} onChange={event => this.props.changeCallback('descr', event.target.value)} />
					{fixDescr}
					<SuggestionList
					values={this.state.descrProposals}
					selectedValue={this.props.descr}
					fieldName="descr"
					callback={this.props.changeCallback}
					/>
					<KeywordUsage
					keywordStats={this.state.descrWordStats}
					translations={!!this.props.translationLanguage}
					words={this.props.descr ? this.text2words(this.props.descr) : []}
					/>
				</div>
			</form>
		);
	}

	changeLanguage(language) {
		this.props.changeCallback('language', language);
		window.localStorage.setItem(this.props.toolSlug + '-language', language);
	}

	async fixData(data) {
		if (!data.keywords) {
			const errors = {
				keywords: window?.t?.ERR_MISSING_FOCUS_KEYWORD,
			};
			this.setState({errors: errors});
			return;
		}

		const newState = {
			errors: {},
		};
		if (data.what === 'title') {
			newState.titleWorking = true;
			newState.titleWorkingMessage = window?.t?.DETECTING_LANGUAGE;
		} else if (data.what === 'description') {
			newState.descrWorking = true;
			newState.descrWorkingMessage = window?.t?.DETECTING_LANGUAGE;
		}
		this.setState(newState);

		if (!data.lang) {
			this.detectLanguage();
		}

		if (data.what === 'title') {
			await this.fixTitle(data.brand, data.lang, data.translationLang, data.keywords, data.markup);
		}
		if (data.what === 'description') {
			await this.fixDescription(data.lang, data.translationLang, data.keywords, data.brand, data.markup);
		}
	}

	async fetchPageData (url) {
		if (!url) {
			this.setState({errors: {
				url: window?.t?.MSG_NO_URL,
			}});
			return;
		}
		const respData = await Fetch.post(`https://${window.location.hostname}/tools/api/get-page-html.php`, {pageUrl: url});

		let {markup} = respData;
		markup = markup.replace(/<img[^>]*>/g,"");
		markup = markup.replace(/<link[^>]*>/g,"");
		markup = markup.replace(/<script[^>]*>/g,"");

		let start = markup.indexOf('<head');
		let end = markup.indexOf('</head') + 6;
		const el = document.createElement('div');
		el.innerHTML = respData.markup.substring(start, end);
		const titleEl = el.querySelector('title');
		let title = titleEl ? titleEl.textContent : '';
		const descrEl = el.querySelector('meta[name="description"]');
		let descr = descrEl ? descrEl.getAttribute('content') : '';

		return {
			url: url,
			title: title,
			descr: descr,
			markup: markup,
		};
	}

	async fetchTop10Urls(keyword, language) {
		const top10 = await Fetch.post(`https://${window.location.hostname}/tools/api/get-top10-results.php`, {
			keyword: keyword,
			language_name: language,
		});
		return top10.status === 'ok' ? {
			urls: top10.urls,
			titles: top10.titles,
			descriptions: top10.descriptions,
		} : null;
	}

	async fetchTop10Data(urls) {
		const data = await Promise.all(
			urls.map((url) => this.fetchPageData(url))
		);
		this.setState({
			top10: data,
		});
		return data;
	}

	async updatePageData() {
		const pageData = await this.fetchPageData(this.props.url);
		if (pageData.title) {
			this.props.changeCallback('title', pageData.title);
		}
		if (pageData.descr) {
			this.props.changeCallback('descr', pageData.descr);
		}
		this.props.changeCallback('markup', pageData.markup);
		this.props.changeCallback('markupSrc', this.props.url);

		return pageData;
	}

	async fixTitle(brand = '', lang, translationLang = '', keyword = '', markup = '') {
		const canProceed = await this.props.updateLimitUsage(this.props.toolSlug);
		if (canProceed.status !== 'ok') {
			alert(window?.t?.FREE_LIMIT_REACHED);
			this.setState({
				titleWorking: false,
				titleWorkingMessage: '',
			});
			return;
		}

		this.setState({
			titleWorking: true,
			titleWorkingMessage: window?.t?.MSG_ANALYZING_SERP,
		});

		const mainKeyword = keyword.split(',')[0].trim().toLocaleLowerCase();
		const top10data = await this.fetchTop10Urls(mainKeyword, lang);
		const wordStats = this.buildWordStats(top10data, 'titles', 5);
		if (this.props.translationLanguage) {
			const wordTranslations = await this.translateWords(wordStats, this.props.language, this.props.translationLanguage);
			if (wordTranslations.status === 'ok') {
				for (let i = 0; i < wordStats.length; i ++) {
					wordStats[i].translation = wordTranslations.translations[i]?.translation;
				}
			}
		}

		const contentEl = document.createElement('div');
		contentEl.innerHTML = markup;
		const h1 = contentEl.querySelector('h1')?.textContent || '';

		this.setState({
			titleWorking: true,
			titleWorkingMessage: window?.t?.MSG_WORKING_TITLE,
		});
		const fixed = await Fetch.post(`https://${window.location.hostname}/tools/api/generate-meta.php`, {
			brand: brand,
			keyword: keyword,
			additionalKeywords: wordStats.map((item) => item.word).join(', '),
			lang: lang,
			translationLang: translationLang,
			markup: markup,
			h1: h1,
			what: 'title',
		});

		if (fixed.status === 'ok') {
			this.setState({
				titleProposals: fixed.data,
				titleWordStats: wordStats,
				titleWorking: false,
				titleWorkingMessage: '',
			});
		} else {
			this.setState({
				titleWorking: false,
				titleWorkingMessage: '',
			});
			console.error(fixed.status, fixed.message);
		}

	}

	async fixDescription(lang, translationLang = '', keyword = '', brand = '', markup = '') {
		const canProceed = await this.props.updateLimitUsage(this.props.toolSlug);
		if (canProceed.status !== 'ok') {
			alert(window?.t?.FREE_LIMIT_REACHED);
			this.setState({
				descrWorking: false,
				descrWorkingMessage: '',
			});
			return;
		}

		this.setState({
			descrWorking: true,
			descrWorkingMessage: window?.t?.MSG_ANALYZING_SERP,
		});

		const mainKeyword = keyword.split(',')[0].trim().toLocaleLowerCase();
		const top10data = await this.fetchTop10Urls(mainKeyword, lang);
		const wordStats = this.buildWordStats(top10data, 'descriptions');
		if (this.props.translationLanguage) {
			const wordTranslations = await this.translateWords(wordStats, this.props.language, this.props.translationLanguage);
			if (wordTranslations.status === 'ok') {
				for (let i = 0; i < wordStats.length; i ++) {
					wordStats[i].translation = wordTranslations.translations[i]?.translation;
				}
			}
		}

		const contentEl = document.createElement('div');
		contentEl.innerHTML = markup;
		const h1 = contentEl.querySelector('h1')?.textContent || '';

		this.setState({
			descrWorking: true,
			descrWorkingMessage: window?.t?.MSG_WORKING_DESCR,
		});

		const fixed = await Fetch.post(`https://${window.location.hostname}/tools/api/generate-meta.php`, {
			brand: brand,
			keyword: keyword,
			additionalKeywords: wordStats.map((item) => item.word).join(', '),
			lang: lang,
			translationLang: translationLang,
			markup: markup,
			h1: h1,
			what: 'description',
		});

		if (fixed.status === 'ok') {
			this.setState({
				descrProposals: fixed.data,
				descrWordStats: wordStats,
				descrWorking: false,
				descrWorkingMessage: '',
			});
		} else {
			this.setState({
				descrWorking: false,
				descrWorkingMessage: '',
			});
			console.error(fixed.status, fixed.message);
		}
	}

	prepareLangOptions() {
		const langOptions = languages.map((lang, index) => {
			let key = 'lang-' + index;
			return (
				<option value={lang.name} key={key}>{window?.t?.LANGUAGES[lang.langCode]}</option>
			);
		});
		return (<>
		<option value=''>{window?.t?.SELECT}</option>
		{langOptions}
		</>);
	}

	buildWordStats(pageData, field, count = 10, translationLang = false) {
		let text = pageData[field].join(' ');
		let words = this.text2words(text);

		const wordStats = [];

		words.forEach((word) => {
			const index = wordStats.findIndex((item) => item.word === word);
			if (index >= 0) {
				wordStats[index].count ++;
			} else {
				wordStats.push({
					word: word,
					count: 1,
				});
			}
		});

		wordStats.sort((a, b) => {
			return a.count > b.count
				? -1
				: a.count < b.count
					? 1
					: 0;
		});

		const stats = wordStats.splice(0, count);

		return stats;
	}

	async translateWords(wordStats, langFrom, langTo) {
		const trans = await Fetch.post(`https://${window.location.hostname}/tools/api/translate.php`, {
			langFrom: langFrom,
			langTo: langTo,
			phrases: wordStats.map((item) => item.word),
		});
		return trans;
	}

	async detectLanguage() {
		const {langDetection, url, markup} = this.props;
		if (!langDetection) {
			alert(window?.t?.AVAILABLE_IN_PAID);
			return;
		}
		if (!url && !markup) {
			this.setState({
				langMessage: window?.t?.NO_URL,
			});
			return;
		}

		this.setState({
			langMessage: window?.t?.DETECTING_LANGUAGE,
		});

		const canProceed = await this.props.updateLimitUsage(this.props.toolSlug);
		if (canProceed.status !== 'ok') {
			this.setState({
				langMessage: canProceed.msg,
			});
			return;
		}

		const result = await Fetch.post(`https://${window.location.hostname}/tools/${this.props.toolSlug}/ajax/detect-language.php`, {
			url: url,
			content: markup,
		});

		if (result.status === 'ok') {
			let detectedLanguage = result.lang.trim();
			this.changeLanguage(detectedLanguage);
			this.setState({
				langMessage: detectedLanguage,
			});
			return detectedLanguage;
		}
		this.setState({
			langMessage: result.message,
		});
	}

	text2words(text = "") {
		if (typeof text !== "string" || ! text) {
			return [];
		}
		const clean = text.trim().toLowerCase().replace(/\s\s+/g, ' ').replace(/[^\p{L}\s]/gu, '');

		const output = clean ? clean.split(/\s+/).filter((word) => !!word) : [];
		return output;
	}

}

export default Form;